import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";
import * as XLSX from 'xlsx';
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { DialogService } from "../../Shared/dialog.service";
import { PartnerService } from "../services/partner.service";
declare var $: any;

@Component({
    selector: 'app-emi-spread-transfer',
    templateUrl: './emi-spread-transfer.component.html',
    styleUrls: ['./emi-spread-transfer.component.scss'],
    standalone: false
})
export class EmiSpreadTransferComponent implements OnInit, AfterViewInit {
  currentUser: any;
  FromDate: any;
  ToDate: any;
  showSpinner: boolean = false;
  Type: any = 'SpredAmount';
  dataSource: any;
  minDate: any;
  VoucherDate: any;
  bulkVoucherDate: any;
  transferAmounts: { [key: number]: number } = {};
  displayedColumns: string[] = [
    'sno',
    'Transfer',
    'CustomerLoanAcNo',
    'PartnerLoanNo',
    'CustomerName',
    'CustomerEmiAmount',
    'PartnerEmiAmount',
    'TransferAmount',
    'OpeningAmount',
    'DRAmount',
    'CRAmount',
    'ClosingAmount',
    'SpredAmount',
  ];
  previewData: any[] = [];
  fileUploaded = false;
  selectedFile: File | null = null;
  selectedRows: any[] = [];
  validationResults: any[] = [];
  showValidationTable: boolean = false;
  validImportEntries: any[] = [];
  invalidImportEntries: any[] = [];
  allImportEntries: any[] = [];
  importValid: boolean = false;
  hasValidated: boolean = false;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('importFileInput') importFileInput!: ElementRef;
  constructor(
    private _Partnerservice: PartnerService,
    private dataSharingService: DataSharingService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialog: DialogService

  ) { }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("EMI Spread Transfer");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser") || '{}');
    this.minDate = new Date(this.currentUser.Data_Freeze?.split("T")[0] || new Date());

  }
  ngAfterViewInit() {
    // Reset when modal is fully hidden
    $('#EMISpreadTransferModel').on('hidden.bs.modal', () => {
      this.resetImportModal();
    });
  }
  getTransferAmount(row: any): number {
    const loanId = row.LMS_LoanId;

    if (this.transferAmounts[loanId] !== undefined) {
      return this.transferAmounts[loanId];
    }

    // Default value based on selected Type
    if (this.Type?.toLowerCase() === 'closingamount') {
      return this.getNumericClosingAmount(row);
    } else {
      return this.getNumericSpreadAmount(row);   // default to Spread
    }
  }

  // Called when user types in the input field
  onTransferAmountChange(row: any, event: any) {
    const loanId = row.LMS_LoanId;
    const newValue = parseFloat(event.target.value) || 0;
    this.transferAmounts[loanId] = newValue;
  }

  // Get final DiffAmount to send to API
  getDiffAmount(row: any): number {
    const loanId = row.LMS_LoanId;

    // If user manually changed the amount, use that
    if (this.transferAmounts[loanId] !== undefined) {
      return this.transferAmounts[loanId];
    }

    // Otherwise use value based on Type
    if (this.Type?.toLowerCase() === 'closingamount') {
      return this.getNumericClosingAmount(row);
    } else {
      return this.getNumericSpreadAmount(row);
    }
  }


  getMAS_EMIDifferenceTransfer() {
    this.showSpinner = true;
    this._Partnerservice.MAS_EMIDifferenceTransfer({
      FromDate: this.FromDate,
      ToDate: this.ToDate
    }).subscribe((res: any) => {
      if (res && res.length > 0) {
        this.showSpinner = false;
        this.dataSource = new MatTableDataSource<any>(res);
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.cdr.detectChanges();
        });
      }
      else {
        this.showSpinner = false;
        this._snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
      }
    });
  }
  Transfer(selectedItems: any) {
    const rowsToTransfer = Array.isArray(selectedItems) ? selectedItems : [selectedItems];

    if (rowsToTransfer.length === 0) {
      this._snackBar.openFromComponent(SnackbarComponent, { data: "Please select at least one row", ...this.configSuccess });
      return;
    }

    if (!this.VoucherDate) {
      this._snackBar.openFromComponent(SnackbarComponent, { data: "Please select Voucher Date", ...this.configSuccess });
      return;
    }

    this.dialog.openConfirmDialog(`Are you sure you want to transfer ${rowsToTransfer.length} selected record(s)?`)
      .afterClosed()
      .subscribe((dialogResult) => {
        if (dialogResult === false) return;

        this.showSpinner = true;

        const requestBody = {
          VoucherDate: this.VoucherDate,
          LoginUserId: this.currentUser?.userId,
          JSON: JSON.stringify(rowsToTransfer.map(row => ({
            Loan_Id: row.LMS_LoanId,
            DiffAmount: this.getDiffAmount(row)     // ← Uses edited or default value
          })))
        };

        this._Partnerservice.MAS_Save_EMIDifferenceTransfer(requestBody).subscribe({
          next: (res: any) => {
            this.showSpinner = false;
            if (res && res[0]?.CODE == 0) {
              this._snackBar.openFromComponent(SnackbarComponent, {
                data: res[0].MSG || "Transfer Successful",
                ...this.configSuccess,
              });
              this.selectedRows = [];
              this.transferAmounts = {};   // Clear edited amounts
              this.getMAS_EMIDifferenceTransfer();
            } else {
              this._snackBar.openFromComponent(SnackbarComponent, {
                data: res[0]?.MSG || "Transfer Failed",
                ...this.configSuccess,
              });
            }
          },
          error: () => {
            this.showSpinner = false;
            this._snackBar.openFromComponent(SnackbarComponent, {
              data: "Error while transferring data",
              ...this.configSuccess,
            });
          }
        });
      });
  }
  changeType() {
    this.transferAmounts = {};     // Clear previously edited amounts
    this.cdr.detectChanges();      // Force table to refresh input fields
  }

  // NEW HELPER METHOD - Returns correct amount based on selected Type
  // getDiffAmount(row: any, type: string): number {
  //   if (!row) return 0;

  //   switch (type?.toLowerCase()) {
  //     case 'spredamount':
  //     case 'spreadamount':
  //       return this.getNumericSpreadAmount(row);   // From SpredAmount

  //     case 'closingamount':
  //       return this.getNumericClosingAmount(row);  // From ClosingAmount

  //     default:
  //       return this.getNumericSpreadAmount(row);   // Default to SpredAmount
  //   }
  // }

  // Helper to get numeric ClosingAmount (in case it's also string)
  getNumericSpreadAmount(row: any): number {
    if (!row?.Spred_Amount) return 0;
    else if (row.Spred_Amount >= 0) {
      const numStr = row.Spred_Amount.toString().replace(/[^0-9.-]+/g, '');
      return parseFloat(numStr) || 0;
    }
    else {
      return 0;
    }

  }
  getNumericClosingAmount(row: any): number {
    if (!row?.Closing_Amount) return 0;
    else if (row.Closing_Amount >= 0) {
      const numStr = row.Closing_Amount.toString().replace(/[^0-9.-]+/g, '');
      return parseFloat(numStr) || 0;
    }
    else {
      return 0;
    }
  }
  exportTable(exporter: any) {
    exporter.exportTable('xlsx', {
      fileName: 'MAS_EMIDifferenceTransfer',
      sheet: 'EMI_Difference_Transfer',
      Props: { Author: this.currentUser.userName }
    });
  }
  isAllSelected(): boolean {
    const selectableRows = this.dataSource?.data?.filter(row =>
      this.getNumericSpreadAmount(row) > 0) || [];

    return selectableRows.length > 0 &&
      selectableRows.every(row => this.selectedRows.includes(row));
  }

  isIndeterminate(): boolean {
    const selectableRows = this.dataSource?.data?.filter(row =>
      this.getNumericSpreadAmount(row) > 0) || [];

    const selectedCount = selectableRows.filter(row =>
      this.selectedRows.includes(row)).length;

    return selectedCount > 0 && selectedCount < selectableRows.length;
  }

  toggleAllSelection(checked: boolean) {
    if (checked) {
      this.selectedRows = this.dataSource?.data?.filter(row =>
        this.getNumericSpreadAmount(row) > 0) || [];
    } else {
      this.selectedRows = [];
    }
  }

  toggleRowSelection(row: any, checked: boolean) {
    if (checked) {
      if (!this.selectedRows.includes(row)) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(r => r !== row);
    }
  }

  isRowSelected(row: any): boolean {
    return this.selectedRows.includes(row);
  }

  clearTable() {
    this.dataSource = null;
    this.selectedRows = [];
  }
  ExportTemplate() {
    const templateData = this.dataSource.data.map(row => {
      return {
        PartnerLoanNo: "",
        DiffAmount: ""
      };
    });

    // Using xlsx library (Recommended)
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(templateData);

    // Add header instructions
    XLSX.utils.sheet_add_aoa(ws, [
      ["PartnerLoanNo", "DiffAmount"],
      ["", ""]
    ], { origin: "A1" });

    XLSX.utils.book_append_sheet(wb, ws, "Import_Template");

    // Download file
    XLSX.writeFile(wb, `EMI_Difference_Import_Template_${new Date().toISOString().slice(0, 10)}.xlsx`);

    this._snackBar.openFromComponent(SnackbarComponent, {
      data: "Import Template Downloaded Successfully (2 Columns)",
      ...this.configSuccess,
    });
  }

  // Replace ImportTable() method
  ImportTable() {
    // Reset state
    this.previewData = [];
    this.fileUploaded = false;
    this.selectedFile = null;
    this.validationResults = [];
    this.showValidationTable = false;
    this.importValid = false;

    // Clear file input value
    const fileInput = document.getElementById('importFileInput') as HTMLInputElement;
    if (fileInput) fileInput.value = '';

    $("#EMISpreadTransferModel").modal("show");
    $("#EMISpreadTransferModel").css("z-index", "1050");
  }

  // Modify onFileChange to store previewData and auto-validate
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (!file) return;

    const fileExtension = file.name.split('.').pop()?.toLowerCase();
    if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
      this._snackBar.openFromComponent(SnackbarComponent, {
        data: "Please upload a valid Excel file (.xlsx or .xls)",
        ...this.configSuccess,
      });
      return;
    }

    this.selectedFile = file;
    this.fileUploaded = true;
    this.previewData = [];

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (jsonData.length < 2) {
        this.showError("Excel file is empty or has no data");
        this.resetFileUpload();
        return;
      }

      const headers = jsonData[0].map((h: any) => h?.toString().trim());
      const requiredColumns = ['PartnerLoanNo', 'DiffAmount'];
      const missingColumns = requiredColumns.filter(col => !headers.includes(col));

      if (missingColumns.length > 0) {
        this.showError(`Missing required columns: ${missingColumns.join(', ')}`);
        this.resetFileUpload();
        return;
      }

      const loanNoIndex = headers.indexOf('PartnerLoanNo');
      const diffAmountIndex = headers.indexOf('DiffAmount');

      const previewData: any[] = [];
      for (let i = 1; i < jsonData.length; i++) {
        const row = jsonData[i];
        if (row.length > Math.max(loanNoIndex, diffAmountIndex)) {
          const loanNo = row[loanNoIndex]?.toString().trim() || '';
          const diffAmount = row[diffAmountIndex];
          let amount = 0;
          if (diffAmount !== undefined && diffAmount !== null) {
            const amountStr = diffAmount.toString().trim();
            amount = parseFloat(amountStr.replace(/[^0-9.-]+/g, '')) || 0;
          }
          if (loanNo || amount > 0) {
            previewData.push({ PartnerLoanNo: loanNo, DiffAmount: amount });
          }
        }
      }

      this.previewData = previewData;
      this.allImportEntries = JSON.parse(JSON.stringify(this.previewData));

      if (this.checkUISideValidation(this.allImportEntries)) {
        this.validateImportData();
      } else {
        this.showValidationTable = true;
        this.hasValidated = false;
      }
    };
    reader.readAsArrayBuffer(file);
  }

  checkUISideValidation(data: any[]): boolean {
    if (!data || data.length === 0) return false;
    return data.every(item => item.PartnerLoanNo && item.DiffAmount && item.DiffAmount > 0);
  }

  validateImportData(isManual: boolean = false) {
    const dataToValidate = isManual ? this.allImportEntries : this.previewData;

    if (!dataToValidate.length) {
      this.showError("No data to validate");
      return;
    }

    this.showSpinner = true;
    const simplifiedData = dataToValidate.map((item: any) => ({
      PartnerLoanNo: item.PartnerLoanNo,
      DiffAmount: item.DiffAmount
    }));

    const requestBody = {
      LoginUserId: this.currentUser.userId,
      JSON: JSON.stringify(simplifiedData)
    };

    this._Partnerservice.MAS_MatchImport_EMIDifferenceTransfer(requestBody).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        if (res && res[0]?.CODE > 0) {
          this.allImportEntries = res;
          this.hasValidated = true;
          this.validImportEntries = res.filter((item: any) => !item.NotMach);
          this.invalidImportEntries = res.filter((item: any) => item.NotMach);
          this.showValidationTable = true;

          if (this.invalidImportEntries.length > 0) {
            this._snackBar.openFromComponent(SnackbarComponent, {
              data: `${this.invalidImportEntries.length} unmatched record(s) found. Please correct them.`,
              ...this.configSuccess,
            });
          } else {
            this._snackBar.openFromComponent(SnackbarComponent, {
              data: `All records matched successfully.`,
              ...this.configSuccess,
            });
          }
        } else {
          this.showError(res[0]?.MSG || res[0]?.Msg || "Validation failed");
        }
      },
      error: () => {
        this.showSpinner = false;
        this.showError("Error while validating data");
      }
    });
  }

  // Update applyImport() to use validImportEntries
  applyImport() {
    if (!this.validImportEntries.length) {
      this.showError("No valid entries to apply");
      return;
    }

    // Match with existing dataSource to get full row objects
    this.validImportEntries.forEach(entry => {
      const matchedRow = this.dataSource?.data?.find((row: any) =>
        row.PartnerLoanNo === entry.PartnerLoanNo
      );
      if (matchedRow) {
        const loanId = matchedRow.LMS_LoanId;
        this.transferAmounts[loanId] = entry.DiffAmount;
        if (!this.selectedRows.includes(matchedRow)) {
          this.selectedRows.push(matchedRow);
        }
      }
    });

    this.cdr.detectChanges();
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: `${this.validImportEntries.length} record(s) imported successfully.`,
      ...this.configSuccess,
    });
    this.onClose(); // Close modal
  }

  // Update resetImportModal()
  private resetImportModal() {
    this.previewData = [];
    this.fileUploaded = false;
    this.selectedFile = null;
    this.validImportEntries = [];
    this.invalidImportEntries = [];
    this.allImportEntries = [];
    this.showValidationTable = false;
    this.hasValidated = false;
    if (this.importFileInput && this.importFileInput.nativeElement) {
      this.importFileInput.nativeElement.value = '';
    }
    this.bulkVoucherDate = null;
  }

  // Update onClose()
  onClose() {
    this.resetImportModal();
    $("#EMISpreadTransferModel").modal("hide");
  }

  // Helper methods
  private showError(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      ...this.configSuccess,
    });
  }

  private resetFileUpload() {
    this.fileUploaded = false;
    this.selectedFile = null;
    this.previewData = [];
    this.importFileInput.nativeElement.value = '';
  }

  // Remove the old onSave() method (or rename to avoid conflict)
  onSave() {
    this.showSpinner = true;

    const simplifiedData = this.allImportEntries.map((item: any) => ({
      PartnerLoanNo: item.PartnerLoanNo,
      DiffAmount: item.DiffAmount
    }));

    const requestBody = {
      VoucherDate: this.bulkVoucherDate,
      LoginUserId: this.currentUser.userId,
      JSON: JSON.stringify(simplifiedData)
    }
    this._Partnerservice.MAS_SaveImport_EMIDifferenceTransfer(requestBody).subscribe({
      next: (res: any) => {
        this.showSpinner = false;
        if (res && res[0]?.CODE == 0) {
          this._snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG || "Transfer Successful",
            ...this.configSuccess,
          });
          this.selectedRows = [];
          this.transferAmounts = {};   // Clear edited amounts
          this.onClose()
          // this.getMAS_EMIDifferenceTransfer();
        } else {
          this._snackBar.openFromComponent(SnackbarComponent, {
            data: res[0]?.Msg || "Transfer Failed",
            ...this.configSuccess,
          });
        }
      },
      error: () => {
        this.showSpinner = false;
        this._snackBar.openFromComponent(SnackbarComponent, {
          data: "Error while transferring data",
          ...this.configSuccess,
        });
      }
    });


  }
  // onFileChange(event: any) {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const fileExtension = file.name.split('.').pop()?.toLowerCase();
  //   if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
  //     this._snackBar.openFromComponent(SnackbarComponent, {
  //       data: "Please upload a valid Excel file (.xlsx or .xls)",
  //       ...this.configSuccess,
  //     });
  //     return;
  //   }

  //   this.selectedFile = file;
  //   this.fileUploaded = true;
  //   this.previewData = [];

  //   const reader = new FileReader();
  //   reader.onload = (e: any) => {
  //     const data = new Uint8Array(e.target.result);
  //     const workbook = XLSX.read(data, { type: 'array' });
  //     const sheetName = workbook.SheetNames[0];
  //     const worksheet = workbook.Sheets[sheetName];

  //     const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

  //     if (jsonData.length < 2) {
  //       this._snackBar.openFromComponent(SnackbarComponent, {
  //         data: "Excel file is empty or has no data",
  //         ...this.configSuccess,
  //       });
  //       this.fileUploaded = false;
  //       this.selectedFile = null;
  //       return;
  //     }

  //     // Extract headers (first row)
  //     const headers = jsonData[0].map((h: any) => h?.toString().trim());

  //     // Validate required columns
  //     const requiredColumns = ['PartnerLoanNo', 'DiffAmount'];
  //     const missingColumns = requiredColumns.filter(col => !headers.includes(col));

  //     if (missingColumns.length > 0) {
  //       this._snackBar.openFromComponent(SnackbarComponent, {
  //         data: `Missing required columns: ${missingColumns.join(', ')}`,
  //         ...this.configSuccess,
  //       });
  //       this.fileUploaded = false;
  //       this.selectedFile = null;
  //       return;
  //     }

  //     // Get column indices
  //     const loanNoIndex = headers.indexOf('PartnerLoanNo');
  //     const diffAmountIndex = headers.indexOf('DiffAmount');

  //     // Process data rows (skip header)
  //     const previewData: any[] = [];
  //     for (let i = 1; i < jsonData.length; i++) {
  //       const row = jsonData[i];
  //       if (row.length > Math.max(loanNoIndex, diffAmountIndex)) {
  //         const loanNo = row[loanNoIndex]?.toString().trim() || '';
  //         const diffAmount = row[diffAmountIndex];

  //         // Validate loan number
  //         if (!loanNo) {
  //           console.warn(`Skipping row ${i + 1}: Missing PartnerLoanNo`);
  //           continue;
  //         }

  //         // Validate and parse diff amount
  //         let amount = 0;
  //         if (diffAmount !== undefined && diffAmount !== null) {
  //           const amountStr = diffAmount.toString().trim();
  //           amount = parseFloat(amountStr.replace(/[^0-9.-]+/g, '')) || 0;
  //         }

  //         // Only add rows with valid loan number and positive amount
  //         if (loanNo && amount > 0) {
  //           previewData.push({
  //             PartnerLoanNo: loanNo,
  //             DiffAmount: amount,
  //           });
  //         }
  //       }
  //     }

  //     this.previewData = previewData;

  //     if (this.previewData.length === 0) {
  //       this._snackBar.openFromComponent(SnackbarComponent, {
  //         data: "No valid data found in the uploaded file",
  //         ...this.configSuccess,
  //       });
  //       this.fileUploaded = false;
  //       this.selectedFile = null;
  //     }
  //   };

  //   reader.readAsArrayBuffer(file);
  // }

}
